export function getSliderEdges(
  { scrollLeft = 0, clientWidth = 0, scrollWidth = 0 },
  tolerance = 1
) {
  return {
    atStart: scrollLeft <= tolerance,
    atEnd: scrollLeft + clientWidth >= scrollWidth - tolerance,
  };
}

export default getSliderEdges;
